import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import ModuleForm from '../Forms/ModuleForm';

const AddEditModuleModal = ({
	dataModule,
	isOpen,
	isEdit,
	handleToggleModal,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar Módulo' : 'Agregar Módulo'}
			</ModalHeader>

			<ModuleForm
				dataModule={dataModule}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
			/>
		</Modal>
	);
};

export default AddEditModuleModal;
